// src/components/CornerImage.js
import React from 'react';
import triangular from '../../assets/images/about/triangular.png';

const CornerImage = ({ position = { bottom: '3px', left: '16%' }, width = '20%' }) => {
    return (
        <img
            src={triangular}
            alt="Triangle"
             loading="lazy"
            style={{
                position: 'absolute',
                bottom: position.bottom,
                left: position.left,
                width: width,
                maxWidth: '90px',
                transform: 'translate(-20%, 20%)', // Offset slightly outside the image if needed
            }}
        />
    );
};

export default CornerImage;
